import { useState, useEffect } from 'react';
import { Col, Modal, Row, Form, Button, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useMutation } from 'react-query';
import { StyledRow, StyledTitle } from './styles';
import CubageHttpService from '../../../../../services/http/cubage-http';
import ProductGroup from '../../../../../constants/ProductGroup';
import handleResponseError from '../../../../../utils/handleResponseError';
import StructuresCubage from '../../../../../shared/interfaces/structures-cubage.interface';

interface FormData {
    quantityLimit: string;
    cubage: string;
}

interface StructuresCubageModalProps {
    selectedStructure: StructuresCubage | null;
    refetch: any;
    show: boolean;
    onHide: () => void;
}

export default function StructuresCubageModal({
    onHide,
    refetch,
    selectedStructure,
    show,
}: StructuresCubageModalProps) {
    const [isDisabled, setDisabled] = useState(true);
    const { register, watch } = useForm<FormData>({
        defaultValues: {
            quantityLimit: selectedStructure
                ? selectedStructure.quantityLimit.toString()
                : '',
            cubage: selectedStructure
                ? selectedStructure.cubage.toString()
                : '',
        },
    });

    const formData = watch();

    const updateMutation = useMutation(
        async () => {
            if (!selectedStructure) {
                throw new Error(
                    'Cubagem do Estrutura não encontrado para atualizar',
                );
            }

            const Structures: any = {
                quantityLimit: Number(formData?.quantityLimit),
                cubage: Number(formData?.cubage),
            };

            await CubageHttpService.update(
                ProductGroup.StructuresCubage,
                selectedStructure.id,
                Structures,
            );

            refetch();
        },
        {
            onError: (error: any) => {
                handleResponseError(
                    error,
                    'Erro ao salvar cubagem da Estrutura',
                );
            },
            onSuccess: async () => {
                toast.success('Observação salva com sucesso');
                onHide();
            },
        },
    );

    const createMutation = useMutation(
        async () => {
            const Structures: any = {
                quantityLimit: Number(formData?.quantityLimit),
                cubage: Number(formData?.cubage),
            };

            await CubageHttpService.create(
                ProductGroup.StructuresCubage,
                Structures,
            );
            refetch();
        },
        {
            onError: (error: any) => {
                handleResponseError(
                    error,
                    'Erro ao salvar cubagem da Estrutura',
                );
            },
            onSuccess: async () => {
                toast.success('Cubagem do Estrutura salva com sucesso');
                onHide();
            },
        },
    );

    useEffect(() => {
        if (
            formData?.quantityLimit?.length > 0 &&
            formData?.cubage?.length > 0
        ) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    }, [formData]);

    const isLoading = updateMutation.isLoading || createMutation.isLoading;

    return (
        <Modal
            className="modal-dialog-scrollable"
            show={show}
            onHide={onHide}
            size="lg"
            centered
        >
            <Modal.Header>
                <Modal.Title
                    className="ml-3 mr-3"
                    id="contained-modal-title-vcenter"
                >
                    Cubagem do Estrutura
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="w-100">
                <StyledRow className="ml-0 mt-4 mr-1">
                    <Col>
                        <StyledTitle>Quantidade limite</StyledTitle>
                    </Col>
                </StyledRow>
                <Row className="ml-0 mt-2 mr-1">
                    <Col>
                        <Form.Control
                            ref={register}
                            name="quantityLimit"
                            type="number"
                            className="form-control-nexen"
                            placeholder="Digite aqui..."
                        />
                    </Col>
                </Row>
                <StyledRow className="ml-0 mt-4 mr-1">
                    <Col>
                        <StyledTitle>Cubagem do Estrutura</StyledTitle>
                    </Col>
                </StyledRow>
                <Row className="ml-0 mt-2 mr-1">
                    <Col>
                        <Form.Control
                            ref={register}
                            name="cubage"
                            type="number"
                            className="form-control-nexen"
                            placeholder="Digite aqui..."
                        />
                    </Col>
                </Row>
                <StyledRow className="ml-0 mt-5 mr-1">
                    <Col sm={6} />
                    <Col>
                        <Button
                            className="w-100 float-right"
                            variant="outline-primary"
                            onClick={() => {
                                onHide();
                            }}
                        >
                            Cancelar
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            className="w-100 float-right"
                            onClick={() => {
                                if (selectedStructure) {
                                    updateMutation.mutate();
                                } else {
                                    createMutation.mutate();
                                }
                            }}
                            disabled={isDisabled}
                        >
                            Salvar{'   '}
                            {isLoading && (
                                <Spinner animation="border" size="sm" />
                            )}
                        </Button>
                    </Col>
                </StyledRow>
            </Modal.Body>
            <Modal.Footer className="ml-3 mr-3 mb-2" />
        </Modal>
    );
}
